import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '@admin/auth/services/authentication.service';

export const authGuard: CanActivateFn = async (route, state) => {
    const auth = inject(AuthenticationService);
    const router = inject(Router);

    if (auth.isAuthenticated()) {
        return true;
    }

    await router.navigate(
        ['/auth/login'],
        { queryParams: { returnUrl: state?.url || '/' } }
    );

    return false;
}
